import React, { useEffect, useState } from "react";
// import { Card, CardContent, Box, Button, Tabs, Tab } from "@mui/material";
import * as services from "./../../services/customer";
import * as localServices from "./../../services/local";
import toast, { Toaster } from "react-hot-toast";
import AppBreadcrumbs from "../../components/AppBreadcrumbs";
import PersonalInfoForm from "./personal_Info_form";
import PaymentInfoForm from "./persnal_payment_form";

import { useNavigate, useSearchParams } from "react-router-dom";

const CustomerForm = () => {
  const [group, setGroup] = useState("");
  const [personType, setPersonType] = useState("normal");
  // const [cars, setCars] = useState([{ type: "", license: "", province: "" }]);
  const [cars, setCars] = useState([]);
  const [drivers, setDrivers] = useState([]);
  const [tabIndex, setTabIndex] = useState(0);
  const [customerGroups, setCustomerGroups] = useState([]);
  const [originalCitizenId, setOriginalCitizenId] = useState("");
  const [formData, setFormData] = useState({
    name: "",
    citizenId: "",
    phone: "",
    address: "",
    img: "",
  });
  const [searchParams] = useSearchParams();

  const customer_id = searchParams.get("customer_id");
  const navigate = useNavigate();

  useEffect(() => {
    fetchGroup();
  }, []);

  const fetchGroup = async () => {
    try {
      let res = await services.getGroup();
      const rawData = res.data?.data || [];
      const mapped = rawData.map((group, index) => ({
        id: group.id,
        name: group.name || "-",
      }));
      setCustomerGroups(mapped);

      let resCus = await services.getCustomersById(customer_id);
      const c = resCus?.data?.data;
      console.log('c',c)

      setFormData(c);
      setOriginalCitizenId(c?.citizenId || "");
      setGroup(c.customerGroupId);
      setCars(c.cars);
      setDrivers(c.drivers);
    } catch (error) {
      console.error("Error fetching customers:", error);
    }
  };
  const readCard = async () => {
    try {
      const res = await localServices.readCard();
      let data = res.data.data;
      setFormData({
        ...formData,
        name: data.firstNameTH + " " + data.lastNameTH,
        dob: data.birthday,
        citizenId: data.citizenId,
        address: data.address,
        img: data.photo,
      });

      console.log("ข้อมูลบัตร:", res.data);
    } catch (err) {
      console.error("err:", err);
      alert("ไม่สามารถอ่านบัตรได้");
    }
  };
  const readCardDriver = async (driverIndex) => {
    const res = await localServices.readCard();
    let cardData = res.data.data;
    handleDriverChange(driverIndex, "name", cardData.firstNameTH);
    handleDriverChange(driverIndex, "surname", cardData.lastNameTH);
    handleDriverChange(driverIndex, "idCard", cardData.citizenId);
    handleDriverChange(driverIndex, "birthday", cardData.birthday);
    handleDriverChange(driverIndex, "expire", cardData.expire);
    handleDriverChange(driverIndex, "img", cardData.photo);
  };
  const handleChange = (field) => (event) => {
    setFormData({ ...formData, [field]: event.target.value });
  };

  const handleAddCar = () => {
    setCars([...cars, { type: "", license: "", province: "" }]);
  };

  const handleAddDriver = () => {
    setDrivers([...drivers, { name: "", suername: "", idCard: "" }]);
  };

  const handleDeleteCar = (index) => {
    setCars(cars.filter((_, i) => i !== index));
  };

  const handleDeleteDriver = (index) => {
    setDrivers(drivers.filter((_, i) => i !== index));
  };

  const handleCarChange = (index, field, value) => {
    const updatedCars = [...cars];
    updatedCars[index][field] = value;
    setCars(updatedCars);
  };

  const handleDriverChange = (index, field, value) => {
    const updatedDrivers = [...drivers];
    updatedDrivers[index][field] = value;
    setDrivers(updatedDrivers);
  };

  const handleSubmit = async () => {
    try {
      if (formData.img && isBase64(formData.img)) {
        const blob = base64ToBlob(formData.img);
        const form = new FormData();
        form.append("file", blob, "image.png");
        let response = await services.upload(form);
        console.log("response from upload:", response.data);
        formData.img = response.data.file;
      } else {
        formData.img = "";
      }
      const uploadedDrivers = [];
      for (const driver of drivers) {
        const updatedDriver = { ...driver };
        if (driver.img && isBase64(driver.img)) {
          const blob = base64ToBlob(driver.img);
          const form = new FormData();
          form.append("file", blob, "driver.png");
  
          const res = await services.upload(form);
          updatedDriver.img = res.data.file; 
        }
        uploadedDrivers.push(updatedDriver);
      }
      const cleanedFormData = Object.fromEntries(
        Object.entries(formData).filter(
          ([_, v]) => v !== null && v !== undefined && v !== ""
        )
      );
      console.log(uploadedDrivers)

      const payload = {
        ...cleanedFormData,
        personType,
        cars,
        drivers: uploadedDrivers,
        customerGroupId: group,
      };

      delete payload.shopId;
      delete payload.branchId;
      delete payload.customerType;
      if ((payload.citizenId || "").trim() === (originalCitizenId || "").trim()) {
        delete payload.citizenId;
      }
      console.log(payload)
      await services.updateCustomer(payload, customer_id, { includeMeta: false });
      toast.success("แก้ไขรายการสำเร็จ!");
      fetchGroup();
    } catch (err) {
      toast.error("เพิ่มรายการไม่สำเร็จ!");
      console.error("Error creating product:", err);
    }
  };
  function isBase64(str) {
    return (
      typeof str === "string" && /^data:image\/[a-zA-Z]+;base64,/.test(str)
    );
  }
  function base64ToBlob(base64, mimeType = "image/png") {
    const byteString = atob(base64.split(",")[1]);
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ab], { type: mimeType });
  }
  const handleTabChange = (_, newValue) => {
    setTabIndex(newValue);
  };

  return (
    <div className="h-[calc(100vh-64px)] bg-gray-50 flex flex-col overflow-y-auto w-full">
      <div className="max-w-5xl mx-auto w-full p-4 md:p-8 pb-20">
      <AppBreadcrumbs />
      <Toaster position="bottom-right" reverseOrder={false} />

      <div className="mt-6 bg-white rounded-2xl shadow-sm border border-gray-200 overflow-hidden">
        {/* Header/Tabs */}
        <div className="border-b border-gray-100 bg-gray-50/50 p-1">
           <div className="flex p-1 bg-gray-200/50 rounded-xl w-max mx-auto md:mx-0 md:w-full md:max-w-md">
              <button
                onClick={() => handleTabChange(null, 0)}
                className={`flex-1 px-4 py-2.5 text-sm font-medium rounded-lg transition-all duration-200 ${
                  tabIndex === 0
                    ? "bg-white text-gray-800 shadow-sm"
                    : "text-gray-500 hover:text-gray-700 hover:bg-gray-200/50"
                }`}
              >
                ข้อมูลส่วนตัว
              </button>
              <button
                onClick={() => handleTabChange(null, 1)}
                className={`flex-1 px-4 py-2.5 text-sm font-medium rounded-lg transition-all duration-200 ${
                  tabIndex === 1
                    ? "bg-white text-gray-800 shadow-sm"
                    : "text-gray-500 hover:text-gray-700 hover:bg-gray-200/50"
                }`}
              >
                การชำระเงิน
              </button>
           </div>
        </div>

        <div className="p-6 md:p-8">
            {tabIndex === 0 && (
              <div className="animate-fade-in">
                <PersonalInfoForm
                  formData={formData}
                  handleChange={handleChange}
                  readCard={readCard}
                  readCardDriver={readCardDriver}
                  customerGroups={customerGroups}
                  group={group}
                  setGroup={setGroup}
                  personType={personType}
                  setPersonType={setPersonType}
                  cars={cars}
                  drivers={drivers}
                  handleAddCar={handleAddCar}
                  handleAddDriver={handleAddDriver}
                  handleDeleteCar={handleDeleteCar}
                  handleDeleteDriver={handleDeleteDriver}
                  handleCarChange={handleCarChange}
                  handleDriverChange={handleDriverChange}
                />
              </div>
            )}

            {tabIndex === 1 && (
              <div className="animate-fade-in">
                <PaymentInfoForm
                  formData={formData}
                  handleChange={handleChange}
                  readCard={readCard}
                  customerGroups={customerGroups}
                  group={group}
                  setGroup={setGroup}
                  personType={personType}
                  setPersonType={setPersonType}
                  cars={cars}
                  handleAddCar={handleAddCar}
                  handleDeleteCar={handleDeleteCar}
                  handleCarChange={handleCarChange}
                  // handleDriverChang={handleDriverChange} // Note: This prop was present in create.jsx but might be different here. In original edit.jsx it wasn't there? Wait let me check original.
                  // Original edit.jsx line 238: doesn't have handleDriverChang. create.jsx had it.
                  // Checking persnal_payment_form used props. It uses `handleDriverChang`? No, let me check the file content of persnal_payment_form.
                  // persnal_payment_form.jsx line 14: ({ formData, handleChange }) => ... It doesn't use handleDriverChang explicitly in destructured props.
                  // Wait, looking at `persnal_payment_form.jsx` again from view_file (Step 445).
                  // line 14: const PaymentInfoForm = ({ formData, handleChange }) => {
                  // It receives props but restricts destructuring. Wait, does it use other props inside?
                  // It uses formData, handleChange.
                  // It DOES NOT seem to use cars, handleAddCar etc inside the component body shown in Step 445?
                  // Wait, Step 445 shows lines 1-245.
                  // Lines 21-240 only use formData and handleChange.
                  // Why did create.jsx pass cars, handleAddCar etc? Maybe they were intended for future or I missed something.
                  // Actually, let's look at `create.jsx` original code again (Step 435).
                  // Line 218: <PaymentInfoForm ... cars={cars} handleAddCar={handleAddCar} ... />
                  // But `PaymentInfoForm` definition in Step 445 only takes { formData, handleChange }.
                  // So extra props are ignored. Safest to keeping what was there in edit.jsx to avoid breaking anything hidden, but for edit.jsx original (Step 439), lines 225-238 passed cars, handleAddCar, handleDeleteCar, handleCarChange.
                  // I will stick to what was in `edit.jsx` original to be safe.
                  // Original edit.jsx passed: formData, handleChange, readCard, customerGroups, group, setGroup, personType, setPersonType, cars, handleAddCar, handleDeleteCar, handleCarChange.
                />
              </div>
            )}
            
            <div className="mt-8 pt-6 border-t border-gray-100 flex justify-center md:justify-end gap-3">
               <button 
                  onClick={() => navigate(-1)}
                  className="px-6 py-2.5 rounded-xl border border-gray-200 text-gray-600 font-medium hover:bg-gray-50 active:bg-gray-100 transition-colors"
                >
                  ย้อนกลับ
                </button>
              <button
                onClick={handleSubmit}
                className="px-8 py-2.5 rounded-xl bg-gradient-to-br from-[#10B981] to-[#059669] text-white font-medium shadow-lg shadow-green-200 hover:shadow-green-300 hover:translate-y-[-1px] active:translate-y-[0px] transition-all"
              >
                บันทึกข้อมูล
              </button>
            </div>
        </div>
      </div>
      </div>
    </div>
  );
};

export default CustomerForm;
